module.exports = __webpack_public_path__ + "static/img/advert_1.33c3e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selfPrinting/advert_1.png
// module id = wSwP
// module chunks = 10